export default "__VITE_ASSET__4bf2bdfd__"